import { SectionImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/sectionImpression.trackingInfo";

import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

import { GoogleAnalyticsEvents } from "../GoogleAnalyticsEvents";
import {
    GoogleAnalyticsMinimumDataset,
    getPageInfo,
    getUserInfo
} from "../GoogleAnalyticsMinimumDataset";

export interface GoogleAnalyticsSectionImpression
    extends GoogleAnalyticsMinimumDataset {
    info: SectionImpressionTrackingInfo;
}

const getGoogleAnalyticsSectionImpression = (
    data: TypedAnalyticsEvent<SectionImpressionTrackingInfo>
): GoogleAnalyticsSectionImpression | undefined => {
    const gtmData = {
        event: GoogleAnalyticsEvents.SectionImpression,
        pageInfo: getPageInfo(data),
        userInfo: getUserInfo(data),
        info: {
            name: data?.payload.eventData?.name
        }
    };

    // minimum data present
    if (gtmData?.info?.name) {
        return gtmData;
    } else {
        return undefined;
    }
};

export { getGoogleAnalyticsSectionImpression };
